import axios from '@axios';
import { logger } from '@/util/logger';
import { version } from '../../package.json';

const os = require('os');

const base = '/api/v1/visit-diagnostics/';

export default {
  async generateReport(prisonerNumber, prisonId, visitId) {
    // const Ip = await fetch('https://jsonip.com').then(res => res.json()).then(data => data.ip);
    const report = {
      visit_id: visitId,
      diagnostics: {
        prison_id: prisonId,
        prisoner_number: prisonerNumber,
        networkInterface: os.networkInterfaces(),
        hostname: os.hostname(), // os.hostname() will just return the domain
        appVersion: version,
      },
    };

    this.sendReport(report).catch(err => {
      logger.error('Could send diagnostics report', err, report, 'DiagnosticsReportService:sendReport');
    });
  },
  sendReport(report) {
    return axios.post(`${base}create`, report);
  },
}
